import * as endpoints from '@App/constants/endpoints';
import * as keys from '@App/constants/keys';
import interceptor from '../interceptor';

const MANAGER = 'manager';
const AGENTS = 'agents';

const _get = async props => {
  const { axios, pathUrl } = props;

  try {
    return (await axios.get(pathUrl)).data;
  } catch (error) {
    if (error && error.response && error.response.status)
      throw {
        status: error.response.status,
        userFeedback: error.response.data.userFeedback,
      };
    throw error;
  }
};

const _post = async (axios, pathUrl, params = {}) => {
  try {
    return (await axios.post(pathUrl, params)).data;
  } catch (error) {
    if (error && error.response && error.response.status)
      throw {
        status: error.response.status,
        userFeedback: error.response.data.userFeedback,
      };
    throw error;
  }
};

const _put = async (axios, pathUrl, params = {}) => {
  try {
    return (await axios.put(pathUrl, params)).data;
  } catch (error) {
    if (error && error.response && error.response.status)
      throw {
        status: error.response.status,
        userFeedback: error.response.data.userFeedback,
      };
    throw error;
  }
};

const _delete = async (axios, pathUrl, params = {}) => {
  try {
    return (await axios.delete(pathUrl, params)).data;
  } catch (error) {
    if (error && error.response && error.response.status)
      throw {
        status: error.response.status,
        userFeedback: error.response.data.userFeedback,
      };
    throw error;
  }
};

export const listAgents = async params => {
  const { accountId, page = 1, limit = 10, search = '', status = '' } = params;

  let pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}?page=${page}&limit=${limit}`;

  if (accountId) {
    pathUrl += `&accountId=${accountId}`;
  }

  if (search) {
    pathUrl += `&search=${encodeURIComponent(search)}`;
  }

  if (status) {
    pathUrl += `&status=${status}`;
  }

  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _get({ axios, pathUrl });
};

export const getAgent = async params => {
  const { agentId } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${MANAGER}/${agentId}`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _get({ axios, pathUrl });
};

export const createAgent = async params => {
  const { body } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${MANAGER}`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _post(axios, pathUrl, body);
};

export const updateAgent = async params => {
  const { agentId, body } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${agentId}`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _put(axios, pathUrl, body);
};

export const deleteAgent = async params => {
  const { agentId } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${agentId}`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _delete(axios, pathUrl, params);
};

export const duplicateAgent = async params => {
  const { agentId } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${agentId}/duplicate`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _post(axios, pathUrl, {});
};

export const registerDocuments = async params => {
  const { agentId, body, header } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/${AGENTS}/${MANAGER}/${agentId}/documents/register`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY, ...header });

  return await _post(axios, pathUrl, body);
};

export const deleteDocument = async params => {
  const { agentId, docId } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/agents/${agentId}/documents/${docId}`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _delete(axios, pathUrl, params);
};

export const testAgent = async params => {
  const { agentId, body } = params;
  const pathUrl = `${endpoints.API_ACCOUNT}/agents/${agentId}/test`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _post(axios, pathUrl, body);
};

export const getAccountAgentAccess = async ({ accountId }) => {
  const pathUrl = `${endpoints.API_ACCOUNT}/${MANAGER}/account/${accountId}/agent-access`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _get({ axios, pathUrl });
};

export const setAccountAgentAccess = async ({ accountId, agentIds }) => {
  const pathUrl = `${endpoints.API_ACCOUNT}/${MANAGER}/account/${accountId}/agent-access`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _put(axios, pathUrl, { agentIds });
};

export const deleteAccountAgentAccess = async ({ accountId }) => {
  const pathUrl = `${endpoints.API_ACCOUNT}/${MANAGER}/account/${accountId}/agent-access`;
  const axios = interceptor({ xApiKey: keys.API_MANAGER_KEY });
  return await _delete(axios, pathUrl);
};


